import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import sharedMutations from 'vuex-shared-mutations'
import auth from './modules/auth'
import online from './modules/online'
import groupsets from './modules/groupsets'
import history from './modules/history'
import logbook from './modules/logbook'
import refueling from './modules/refueling'
import events from './modules/events'
import contracts from './modules/contracts'
import service from './modules/service'
import data from './modules/data'
import vehicleLog from './modules/vehicleLog'
import progress from './modules/progress'
import report from './modules/report'
import dialogs from './modules/dialogs'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: (state) => {
    // ukladat pouze uzivatele z auth modulu
    return { auth: { user: state.auth.token } }
  },
  filter: (mutation) => {
    // reagovat pouze na zmenu prihlaseneho uzivatele - musi tu byt vsechny mutace, ktere meni property user
    return ['auth/setUser', 'auth/logout'].includes(mutation.type)
  },
  // modules: ['auth'] // ukladat cely auth modul - v tomto pripade nema smysl reducer a filter, ale uklada to i chyby a odhlasovaci zpravy
})

export default new Vuex.Store({
  modules: {
    auth,
    online,
    groupsets,
    history,
    logbook,
    refueling,
    events,
    contracts,
    service,
    data,
    vehicleLog,
    progress,
    report,
    dialogs
  },
  plugins: [
    vuexLocal.plugin,
    sharedMutations({ predicate: ['auth/setUser', 'auth/logout'] }),
  ],
})
